import React, { Component } from 'react';
import firebase from 'firebase';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import ReduxThunk from 'redux-thunk';
import reducers from './reducers';
import HomePage from './Home/HomePage';

class App extends Component {
  componentWillMount(){
    const {config} = this.props;
    if(config === undefined)
    {
      throw new Error("No config prop found!")
    }
    firebase.initializeApp(config);
  }
  render() {
    const store = createStore(reducers, {}, applyMiddleware(ReduxThunk));
    return (
      <Provider store={store}>
        <HomePage />
       </Provider>
    );
  };
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js